import { useCallback, useEffect, useState } from 'react';
import api from 'services/api';
import Error from 'components/Snack/Error';

export default function useAddress({ setFieldValue, recoverState }) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [errorCep, setErrorCep] = useState(null);
  const [loadingStates, setLoadingStates] = useState(false);
  const error = Error();

  useEffect(() => {
    async function load() {
      // carrega o fornecerdor caso tenha id, do contrario carrega vazio para cadastrar um novo
      setLoadingStates(true);

      const loadStates = await api.get(
        'https://servicodados.ibge.gov.br/api/v1/localidades/estados',
      );

      if (loadStates.data.length !== 0) {
        setStates(loadStates.data);
      }

      if (recoverState?.data?.uf) {
        const tempState = loadStates.data.filter(
          (state) => state.sigla === recoverState.data.uf,
        )[0];
        handleStateSelect(tempState);
      }

      setLoadingStates(false);
    }
    load();
  }, [recoverState?.data?.uf]);

  const handleStateSelect = useCallback(async (state) => {
    setFieldValue('state', state.nome);
    setFieldValue('uf', state.sigla);
    setSelectedState(state);
    setFieldValue('city', '');

    setSelectedCity(null);

    try {
      const loadCities = await api.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state.sigla
        }/municipios`,
      );
      setCities(loadCities.data);
      if (recoverState?.data?.city) {
        const tempCity = loadCities.data.filter(
          (city) => city.nome === recoverState.data.city,
        )[0];

        setSelectedCity(tempCity);
        setFieldValue('city', tempCity.nome);
      }
    } catch (e) {
      error('Ocorreu um erro ao buscar as cidades.');
    }
  }, [recoverState?.data?.city, setFieldValue]);

  const handleCitySelect = (city) => {
    setFieldValue('city', city.nome);
    setSelectedCity(city);
  };

  const clearFieldsForUnknownZipCode = () => {
    handleStateSelect('');
    handleCitySelect('');
    setFieldValue('street', '');
    setFieldValue('neighborhood', '');
  };

  async function onBlurCep(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        setErrorCep(data.erro);
        clearFieldsForUnknownZipCode();
        return;
      }

      const findState = states.find((state) => state.sigla === data.uf);
      const city = { nome: data.localidade };

      handleStateSelect(findState);
      handleCitySelect(city);
      setFieldValue('cep', cep);

      if (data.logradouro) {
        setFieldValue('street', data.logradouro);
      }

      if (data.bairro) {
        setFieldValue('neighborhood', data.bairro);
      }

      setFieldValue('uf', data.uf);
      setFieldValue('city', data.localidade);
      setErrorCep(false);
    } catch (e) {

    }
  }

  return {
    onBlurCep,
    states,
    selectedState,
    handleStateSelect,
    cities,
    selectedCity,
    errorCep,
    handleCitySelect,
    loadingStates,
  };
}
